export default {
    maxDate: `You must be at least 13 years old`,
    minDate: `You don't look that old!`,
    invalidDate: `Invalid date`,
};
